import {ReportData} from "../../../reports/report.data";
import {collection} from "@fedeltapointofsale/data-client";
import {InventoryBarcodeReportSelectionData} from "../../inventory-barcode/controls/inventory-barcode-report-selection-control.component";

export class InventoryBarcodeReportData extends ReportData<InventoryBarcodeReportData> {

    @collection(InventoryBarcodeReportSelectionData) barcodes: InventoryBarcodeReportSelectionData[];
}
